export default "__VITE_ASSET__Bu2clo8P__"